<script>
    export default {
        name: "eda-order-line",
        props: {
            id: {type: String, default: ""},
            articleId: {type: String, default: ""},
            name: {type: String, default: ""},
            model: {type: String, default: ""},
            description: {type: String, default: ""},
            price: {type: Number, default: 0},
            vat: {type: Number, default: 0},

            lineTotal: {type: Number, default: 0},
            quantity: {type: Number, default: 0},
            imageUrl: {type: String, default: ""},
            showPrice: {type: Boolean, default: true},
        },
        data() {
            return {
                canShowPrice: this.showPrice
            }
        },
        computed: {
            imgServerUrl() {
                return this.imageUrl.length ? this.imageUrl : "";
            }
        },
        mounted() {
            if (this.price === null) {
                this.canShowPrice = false;
            }

            if (this.price === 0) {
                this.canShowPrice = false;
            }

        }
    }
</script>

<template>
    <div class="eda-oline">
        <div class="eda-oline__image">
            <img class="eda-oline__img" v-if="imageUrl.length" :src="imgServerUrl">
        </div>
        <div class="eda-oline__data">

            <div class="eda-oline__title">
                <div class="eda-oline__title-main">
                    {{ model }}
                </div>

            </div>


            <div class="eda-oline__details">
                <div> {{ description }}</div>
            </div>

        </div>
        <div class="eda-oline__summary">
       <!--     <div class="eda-oline__quantity" v-if="quantity != 1">
                {{ quantity }} stk.
            </div>
            -->

            <div class="eda-oline__price" v-if="canShowPrice">
                {{ price }},-
            </div>
        </div>


    </div>

</template>

<style>
    .eda-oline {
        display: flex;
        padding: 1em 0;
        justify-content: space-between;
        border-bottom: 1px solid #f1f1f1;
    }

    .eda-oline__image {
        width: 5em;
        height: 5em;
        flex: none;
        background-color: #DDD;
        margin-right: 1em;
    }

    .eda-oline__img {
        width: 100%;
    }

    .eda-oline__data {
        width: 20em;
        padding-right: 1em;
    }

    .eda-oline__title {
        font-size: 0.9em;
        display: flex;
        justify-content: flex-start;
    }

    .eda-oline__title-main {
        font-weight: 600;
        color: #232323;
        padding-right: 0.5em;
    }

    .eda-oline__details {
        font-size: 0.75em;
        color: #8e8e8e;

    }

    .eda-oline__price {
        font-weight: 600;
        flex: none;
        padding-left: 1em;
        text-align: right;
        color: #6B6B6B;
        font-size: 1.1em;
    }

    .eda-oline__summary {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .eda-oline__quantity {
        font-weight: 600;
        min-width: 3em;
        text-align: right;
    }

    .eda-oline__title-suffix {
        font-weight: 300;
        color: green;
    }

</style>